import { render } from "./BrowserLogs.vue?vue&type=template&id=24215855"
import script from "./BrowserLogs.vue?vue&type=script&lang=js"
export * from "./BrowserLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__